// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__tzPql","footer":"ReportModalFilter_footer__3U2k0"};